import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';
import ArrowBack from '@mui/icons-material/ArrowBack';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

interface VaultMatterHeaderProps {
  matterName: string;
  onBack: () => void;
  isLoading?: boolean;
}

export default function VaultMatterHeader({
  matterName,
  onBack,
  isLoading,
}: VaultMatterHeaderProps) {
  const theme = useTheme();
  return (
    <>
      <Stack direction="row" alignItems="flex-start" gap={1}>
        <Stack direction="row" alignItems="center" gap={1} sx={{ mt: '2px' }}>
          <IconButton
            onClick={onBack}
            size="small"
            sx={{ ml: -1 }}
            disabled={isLoading}
          >
            <ArrowBack
              fontSize="small"
              sx={{ color: theme.palette.semantic.breadcrumbs.label.inactive }}
            />
          </IconButton>

          {isLoading ? (
            <>
              <Skeleton variant="text" width={100} height={30} />
              <KeyboardArrowRight
                fontSize="small"
                sx={{ color: theme.palette.semantic.breadcrumbs.arrow }}
              />
            </>
          ) : (
            <>
              <Typography
                variant="h6"
                fontWeight={500}
                sx={{
                  cursor: 'pointer',
                  color: theme.palette.semantic.breadcrumbs.label.inactive,
                }}
                onClick={onBack}
              >
                Matters
              </Typography>
              <KeyboardArrowRight
                fontSize="small"
                sx={{ color: theme.palette.semantic.breadcrumbs.arrow }}
              />
            </>
          )}
        </Stack>

        <Stack direction="column">
          {isLoading ? (
            <>
              <Skeleton variant="text" width={200} height={30} />
              <Skeleton variant="text" width={130} height={20} />
            </>
          ) : (
            <>
              <Typography
                variant="h6"
                fontWeight={500}
                lineHeight={1.7}
                sx={{ color: theme.palette.semantic.text.title2 }}
              >
                {matterName}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.semantic.text.body, pt: -1 }}
              >
                For Decommissioning
              </Typography>
            </>
          )}
        </Stack>
      </Stack>
      <Divider
        sx={{
          borderColor: theme.palette.semantic.outline.light,
        }}
      />
    </>
  );
}
